function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import classNamesMaker from "classnames";
import { overrideProps } from "#library/components/FieldLayout/utils";
import { FieldLabel } from "#library/components/FieldLayout/FieldLabel";
import { FieldWrapper } from "#library/components/FieldLayout/FieldWrapper";
import { FieldSwitchText } from "#library/components/FieldLayout/FieldSwitchText";
import { FieldContainer } from "#library/components/FieldLayout/FieldContainer";
import styles from "#library/components/SelectFilter/select.module.css";
import { Select } from "./Select";
var selectDefaultProps = {
  className: "",
  hasError: false,
  isAsync: false,
  isMenuVisibleOnFocus: false,
  isCreatable: false,
  isMulti: false,
  informationCell: null,
  linkCell: null,
  placeholder: "",
  options: [],
  noInteractionBorder: false
};
export var SelectField = function SelectField(_ref) {
  var _ref$commonProps = _ref.commonProps,
    commonProps = _ref$commonProps === void 0 ? {
      hasError: false
    } : _ref$commonProps,
    _ref$containerProps = _ref.containerProps,
    containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
    _ref$labelProps = _ref.labelProps,
    labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
    _ref$fieldWrapperProp = _ref.fieldWrapperProps,
    fieldWrapperProps = _ref$fieldWrapperProp === void 0 ? {} : _ref$fieldWrapperProp,
    _ref$switchTextProps = _ref.switchTextProps,
    switchTextProps = _ref$switchTextProps === void 0 ? {} : _ref$switchTextProps,
    fieldProps = _ref.fieldProps,
    _ref$linkedPictoProps = _ref.linkedPictoProps,
    _ref$linkedPictoProps2 = _ref$linkedPictoProps === void 0 ? {} : _ref$linkedPictoProps,
    picto = _ref$linkedPictoProps2.picto;
  var initialFieldProps = _objectSpread(_objectSpread({}, selectDefaultProps), fieldProps);
  var labelPropsWithId = _objectSpread(_objectSpread({}, labelProps), {}, {
    id: fieldProps.id
  });

  // Field overrides
  var overriddenFieldProps = _objectSpread(_objectSpread(_objectSpread({}, initialFieldProps), fieldProps), {}, {
    hasError: fieldProps.hasError || commonProps.hasError,
    required: fieldProps.required || commonProps.required,
    isDisabled: fieldProps.isDisabled || commonProps.isDisabled
  });
  var _overrideProps = overrideProps({
      commonProps: commonProps,
      labelProps: labelPropsWithId,
      containerProps: containerProps,
      switchTextProps: switchTextProps,
      fieldWrapperProps: fieldWrapperProps
    }),
    overriddenContainerProps = _overrideProps.overriddenContainerProps,
    overriddenFieldWrapperProps = _overrideProps.overriddenFieldWrapperProps,
    overriddenLabelProps = _overrideProps.overriddenLabelProps,
    overriddenSwitchTextProps = _overrideProps.overriddenSwitchTextProps;
  overriddenFieldWrapperProps.className = classNamesMaker(styles["jds-Select__linkedPictoWrapper"], overriddenFieldWrapperProps.className);
  var pictoClassName = classNamesMaker(styles["jds-Select__linkedPicto"], _defineProperty({}, styles["jds-Select__linkedPicto--disabled"], commonProps.isDisabled), _defineProperty({}, styles["jds-Select__linkedPicto--error"], commonProps.hasError));
  return /*#__PURE__*/React.createElement(FieldContainer, overriddenContainerProps, labelProps.label && /*#__PURE__*/React.createElement(FieldLabel, overriddenLabelProps), /*#__PURE__*/React.createElement(FieldWrapper, overriddenFieldWrapperProps, /*#__PURE__*/React.createElement(Select, overriddenFieldProps), picto && /*#__PURE__*/React.createElement("div", {
    className: pictoClassName,
    "aria-hidden": "true"
  }, picto)), /*#__PURE__*/React.createElement(FieldSwitchText, overriddenSwitchTextProps));
};